<template>
    <svg :class="hoverClass" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"> 
    <polygon points="12 5 7 5 7 0 5 0 5 5 0 5 0 7 5 7 5 12 7 12 7 7 12 7 12 5"/> 
</svg>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
    
    forceHover: {
        type: Boolean,
        required: false,
        default: false
    }
    
});


const hoverClass = computed(() => {
    return {
        'hover-enabled': !props.forceHover,
        'hover-disabled': props.forceHover,        
        'hover-force': props.forceHover
        
    }
});
    

</script>

<style scoped> 
svg {
    cursor: pointer;
    transition: transform 0.1s;
}


svg.hover-force{
    transform: rotate(45deg);
}



</style>